import { atomFamily } from "jotai/utils";
import { SessionConfig } from "../types/SessionConfig";
import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionConfig = atomFamily((sessionId: string) => createPersistedAtom<SessionConfig | undefined>(`sessionConfig-${sessionId}`, {}));
export const sessionConfigAtom = createDerivedSessionAtom<SessionConfig | undefined>(sessionConfig);
